import NameRenderer from "./table-renderer/Name";
import ChannelsRenderer from "./table-renderer/Channels";
import ProfilesRenderer from "./table-renderer/Profiles";
import ProceduresRenderer from "./table-renderer/Procedures";
import RowSelectionRenderer from "./table-renderer/RowSelection";
import StringTruncated from "@/components/ui/table-renderer/StringTruncated";

export const watchmanColumns = (window) => {
  const baseSorting = {
    activeSort: false,
    sortable: true,
    showPopup: false,
  }
  return [
    {
      key: null,
      label: '',
      renderer: RowSelectionRenderer,
      width: "40px"
    },
    {
      ...baseSorting,
      key: "name",
      label: window.V.$i18n.t("watchmen.list.columns.name"),
      renderer: NameRenderer,
      activeSort: '+',
      filter: {
        type: 'text'
      },
      activeFilter: '',
    },
    {
      ...baseSorting,
      key: "description",
      label: window.V.$i18n.t("watchmen.list.columns.description"),
      renderer: StringTruncated,
    },
    {
      key: "channels",
      label: window.V.$i18n.t("watchmen.list.columns.channels"),
      // width: "50%",
      renderer: ChannelsRenderer,
    },
    {
      key: "profiles",
      label: window.V.$i18n.t("watchmen.list.columns.profiles"),
      renderer: ProfilesRenderer,
      width: "80px",
    },
    {
      key: "rm_procedures",
      label: window.V.$i18n.t("watchmen.list.columns.rm_procedures"),
      renderer: ProceduresRenderer,
      width: "140px",
    },
  ];
};
